import {
  AfterViewInit,
  Directive,
  ElementRef,
  Input,
  NgZone,
  OnDestroy,
  Renderer2,
} from '@angular/core';

@Directive({
  selector: '[appInView]',
  standalone: true,
})
export class InViewDirective implements AfterViewInit, OnDestroy {
  @Input() inViewClass = 'is-inview';
  @Input() inViewOnce = true;
  @Input() inViewRootMargin = '-60px';
  @Input() inViewThreshold: number | number[] = 0.15;

  private observer: IntersectionObserver | null = null;

  constructor(
    private host: ElementRef<HTMLElement>,
    private renderer: Renderer2,
    private zone: NgZone
  ) {}

  ngAfterViewInit(): void {
    const el = this.host?.nativeElement;
    if (!el) {
      return;
    }

    if (typeof IntersectionObserver === 'undefined') {
      this.renderer.addClass(el, this.inViewClass);
      return;
    }

    this.zone.runOutsideAngular(() => {
      this.observer = new IntersectionObserver(
        (entries) => {
          const entry = entries?.[0];
          if (!entry) return;

          if (entry.isIntersecting) {
            this.renderer.addClass(el, this.inViewClass);
            if (this.inViewOnce) {
              this.observer?.disconnect();
              this.observer = null;
            }
          } else if (!this.inViewOnce) {
            this.renderer.removeClass(el, this.inViewClass);
          }
        },
        {
          root: null,
          rootMargin: this.inViewRootMargin,
          threshold: this.inViewThreshold,
        }
      );

      this.observer.observe(el);
    });
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
    this.observer = null;
  }
}
